module.exports = __webpack_public_path__ + "img/galactica_blueprints_cover.ade830e5.jpg";